module.exports = __webpack_public_path__ + "350dbdad47f0e8f1874f6b83ffca2773.png";